import { motion } from 'framer-motion'
import React, { FunctionComponent } from 'react'
import { useInView } from 'react-intersection-observer'
import Colors from '../../../tokens/Colors'
import iconQuotes from '../../../images/icon-quotes.svg'
import { mediaQueries } from '../../../utils/mediaQueries'
import { rem } from '../../../utils/rem'
import styled from 'styled-components'
import Title, { TitleProps, TitleSizes } from '../title/Title'
import { artistAnimation, quotesAnimation, textAnimation } from './animations'

export interface QuoteProps {
  artist: string
  className?: string
  quote: string
}

const Quote: FunctionComponent<QuoteProps> = ({ artist, className, quote }) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  })

  return (
    <StyledQuote className={className} ref={ref}>
      <Quotes
        animate={inView ? ['opacityIn', 'transformIn'] : 'initial'}
        src={iconQuotes}
        variants={quotesAnimation}
      />
      <Text
        animate={inView ? ['opacityIn', 'transformIn'] : 'initial'}
        dangerouslySetInnerHTML={{ __html: quote }}
        variants={textAnimation}
      />
      <ArtistWrapper
        animate={inView ? ['opacityIn', 'transformIn'] : 'initial'}
        variants={artistAnimation}
      >
        <Artist level="h3" size={TitleSizes.xSmall}>
          {'- '}
          {artist}
        </Artist>
      </ArtistWrapper>
    </StyledQuote>
  )
}

const StyledQuote = styled.blockquote`
  text-align: center;
`

const Quotes = styled(motion.img)`
  display: block;
  width: ${rem(22)};
  height: ${rem(17)};
  opacity: 0.6;
  margin: 0 auto ${rem(16)};
`

const Text = styled(motion.p)`
  font-size: ${rem(40)};
  line-height: 1;
  color: ${Colors.OSLO_GREY};
  opacity: 0.6;
  margin: 0 0 ${rem(16)};
  letter-spacing: -0.04em;

  ${mediaQueries.tablet} {
    font-size: ${rem(50)};
  }
`

const ArtistWrapper = styled(motion.div)``

const Artist = styled(Title)<TitleProps>`
  color: ${Colors.SHIP_GREY};
`

export default Quote
